<template>
  <div class="sort-container" ref="wrapper">
    <!-- BOTÓN -->
    <button class="sort-btn" @click="open = !open">
      <span class="icon">⇅</span>
      Ordenar por
      <span class="caret">▾</span>
    </button>

    <!-- DROPDOWN -->
    <div v-if="open" class="sort-menu">
      <div
        v-for="opt in options"
        :key="opt.value"
        class="sort-item"
        :class="{ active: sortBy === opt.value }"
        @click="select(opt.value)"
      >
        {{ opt.label }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useSort } from "@/components/composables/useSort";
import { ref } from "vue";

const { sortBy, setSort } = useSort();

const open = ref(false);
const wrapper = ref(null);

const options = [
  { label: "Destacados", value: "featured" },

  // 🔥 NUEVO — OFERTAS PRIMERO
  { label: "Ofertas primero", value: "offers_first" },

  { label: "Precio: mayor a menor", value: "price_desc" },
  { label: "Precio: menor a mayor", value: "price_asc" },
  { label: "De la A a la Z", value: "az" },
  { label: "De la Z a la A", value: "za" }
];

function select(val) {
  setSort(val);
  open.value = false;
}
</script>

<style scoped>
.sort-container {
  position: relative;
}

/* BOTÓN */
.sort-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}

/* DROPDOWN */
.sort-menu {
  position: absolute;
  right: 0;
  top: 110%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,.12);
  min-width: 240px;
  z-index: 50;
  overflow: hidden;
}

/* ITEM */
.sort-item {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
}

.sort-item:hover {
  background: #f5f5f5;
}

.sort-item.active {
  font-weight: 700;
  background: #eef5ff;
}

.icon {
  font-size: 16px;
}

.caret {
  margin-left: 4px;
}

/* 📱 MOBILE — alineado a la derecha */
@media (max-width: 600px) {
  .sort-container {
    align-self: flex-end;
  }
}
</style>


<style scoped>
.sort-container {
  position: relative;
}

.sort-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

.sort-menu {
  position: absolute;
  right: 0;
  top: 110%;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,.12);
  min-width: 240px;
  z-index: 50;
  overflow: hidden;
}

.sort-item {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
}

.sort-item:hover {
  background: #f5f5f5;
}

.sort-item.active {
  font-weight: 700;
  background: #eef5ff;
}

.icon {
  font-size: 16px;
}

.caret {
  margin-left: 4px;
}


@media (max-width: 600px) {
  .cat-header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .sort-container {
    margin-left: auto;
  }
}

</style>
